<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>

<div style="display: flex; justify-content: space-between">
    <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
    <site-search
        [insightSearch]="true"
        style="margin-right: -10px; margin-top: -13px"
    ></site-search>
</div>
<div class="displayopt-actionpanel-layout incentives-display-options">
    <div class="display-options-action-panel-area">
        <display-options
            (displayOptionsOutput)="applyDisplayOptions($event)"
            [showCompareToDate]="false"
            [extraParameters]="extraParameters"
        >
        </display-options>
        <div class="toggle-switch-area">
            <chart-switch
                *ngIf="records"
                [switchLabel]="switchLabel"
                [checked]="showNames"
                (change)="toggleDataLabels()"
                style="margin-right: 13px"
            >
            </chart-switch>
            <action-panel
                [showExportCsv]="false"
                [showSaveAsPdf]="true"
                [showPrint]="false"
                [title]="pageHeadline.pageTitle"
            >
            </action-panel>
        </div>
    </div>
</div>

<div class="incentives-loan-profitability-container">
    <div class="incentives-loan-profitability-table-area">
        <div class="incentives-loan-profitability-table" *ngFor="let cardData of topBottomCardData">
            <div class="top-bottom-div">
                <div class="table-title">{{ cardData.title }}</div>
                <div *ngIf="!noDataForCompany" class="lg-scrollbar">
                    <div *ngIf="loading">
                        <spin-loader [type]="'spinner'" class="table-spinner"></spin-loader>
                    </div>
                    <table *ngIf="!loading && records && records.length" class="profit-table">
                        <tr *ngIf="!loading">
                            <th class="table-header-text" colspan="2"></th>
                            <th class="table-header-number" align="right">Volume</th>
                            <th class="table-header-number">Profit (Loss)</th>
                            <th class="table-header-number" align="right">&nbsp;BPS</th>
                        </tr>
                        <ng-container *ngFor="let entity of cardData.data; index as i">
                            <tr (mouseenter)="mouseEnter(entity)" (mouseleave)="mouseLeave(entity)">
                                <td class="table-data-text">{{ cardData.startingNumber + i }}.</td>
                                <td class="table-data-text-long">
                                    &nbsp;
                                    <span
                                        class="hyperlink-text"
                                        (click)="topBottomNameClickHandler(entity)"
                                    >
                                        {{ entity.hierarchy | slice: 0:14 }}
                                    </span>
                                </td>
                                <td class="table-data-number">
                                    {{ entity.volume | currency: 'USD':'symbol':'1.0-0' }}
                                </td>
                                <td class="table-data-number">{{ entity.revenueFormatted }}</td>
                                <td class="table-data-number">
                                    {{ entity.bps.toFixed(3) }}
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
                <div *ngIf="noDataForCompany">
                    <no-data-screen [noDataType]="noDataType"></no-data-screen>
                </div>
            </div>
        </div>
    </div>
    <div id="scatterplot-graph" class="incentives-loan-profitability-chart-area">
        <large-card
            class="incentives-loan-profitability-chart"
            [largeCardInteriorOptions]="largeCardOptions"
        ></large-card>
    </div>
</div>
